/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum PortalFiltersKeys {
    SiteKey = 'siteFilter',
    OrganizationKey = 'companyFilter',
    LocationKey = 'locationFilter',
}
